import type { FlagConfiguration } from '@atlassian/jira-flags/src/services/types';
import messages from './messages';

export const VALIDATION_FAILED_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.validationErrorFlagTitle,
	description: messages.validationErrorFlagMessage,
};
